var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { is_mobile } = options; 
__p+='\n\n\n';
 if (MOVE_DATA.isDesktop || is_mobile) { 
__p+='\n  <div class="col-qv-xs-12 col-qv-sm-12 col-qv-md-12 col-qv-lg-7 label-wrap qv-promo-label">\n    <span class="label c_label label-white label-outline-promo" data-label="property-label-enhanced">\n      ENHANCED\n    </span>\n    ';
 if(!is_mobile) { 
__p+='\n      <span class="promo-text">Listings with richer content</span>\n    ';
 } 
__p+='\n  </div>\n';
  } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/optimization/enhanced-label.jst.ejs